import { PopoverProps } from 'react-tiny-popover';

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340427475202
 */
export enum TooltipColors {
  BLACK = 'black',
  RED = 'red',
  WHITE = 'white',
  EGGPLANT = 'eggplant',
}

export interface TooltipProps extends Omit<PopoverProps, 'isOpen' | 'content' | 'children'> {
  className?: string;
  content: React.ReactNode;
  isOpen?: boolean;
  showArrow?: boolean;
  showShadow?: boolean;
  /** If true (default), append an info circle icon after `children` */
  showInfoCircle?: boolean;
  tooltipColor?: TooltipColors;
  tooltipMaxWidth?: string;
  isDisabled?: boolean;
}
